export default {
  'nav.home': 'Accueil',
  'nav.shoppingGuide': 'Guide d\'achat',
  'nav.categories': 'Catégories',
  'nav.faq': 'FAQ',
  'nav.mainSite': 'Visiter le site principal',
  'nav.language': 'Langue',

  'hero.eyebrow': 'Ressource indépendante · Mis à jour 2026',
  'hero.title': 'Guide Basetao Spreadsheet',
  'hero.subtitle':
    'Trouvez, comparez et organisez des produits avec des ressources pratiques Basetao Spreadsheet, des guides de recherche, des découvertes, des informations sur la livraison et des avis — tout en un lieu indépendant.',
  'hero.ctaPrimary': 'basetao spreadsheet',
  'hero.ctaSecondary': 'achetez maintenant',
  'hero.ctaGuide': 'Explorez le guide complet',

  'categories.title': 'Parcourir par catégorie',
  'categories.subtitle':
    'Choisissez une catégorie ci-dessous pour accéder directement aux listes de produits sur le site principal.',
  'categories.dropdownLabel': 'Sélectionnez une catégorie',

  'guide.title': 'Qu\'est-ce qu\'un Basetao Spreadsheet ?',
  'guide.lead':
    'Un Basetao Spreadsheet est un moyen simple d\'organiser les produits que vous découvrez, de comparer les prix et les vendeurs, et de conserver chaque lien et détail de livraison dans un endroit clair.',

  'article.title': 'Explorez les guides Basetao',
  'article.subtitle': 'Dix guides piliers approfondis pour vous aider à rechercher, expédier et économiser plus intelligemment.',
  'article.readMore': 'Lire l\'article',

  'faq.title': 'Questions fréquentes',
  'faq.subtitle': 'Réponses rapides sur Basetao Spreadsheet et ce site.',

  'cta.title': 'Prêt à continuer vos recherches ?',
  'cta.subtitle':
    'Continuez votre recherche de produits avec nos guides, ou dirigez-vous vers le site principal pour commencer à construire vos propres découvertes.',
  'cta.mainSite': 'Visiter le site principal',
  'cta.guide': 'Continuez vos recherches',

  'footer.tagline':
    'Une ressource d\'information indépendante sur Basetao Spreadsheet. Non affiliée ni approuvée par Basetao.',
  'footer.resources': 'Ressources',
  'footer.company': 'Société',
  'footer.languages': 'Langues',
  'footer.disclaimer':
    'Basetao Sheet Guide est un site d\'information indépendant et n\'est pas affilié ni approuvé par Basetao, sauf indication explicite.',

  'hero.demoLabel': 'Données de démonstration uniquement à titre d\'illustration.',
  'guide.readFullGuide': 'Lire le guide complet',
  'guide.exampleLabel': 'Structure de feuille de calcul d\'exemple (données de démo)',

  'article.faqTitle': 'Questions fréquentes',
  'article.relatedTitle': 'Guides connexes',
  'article.ctaTitle': 'Continuez vos recherches',
  'article.ctaText':
    'Prêt à commencer à ajouter des produits à votre feuille ? Explorez les catégories ou revenez à la page d\'accueil pour plus de ressources.',
  'article.backToHome': 'Retour à l\'accueil',
  'article.visitMainSite': 'Visiter le site principal',
  'article.author': 'Équipe Basetao Sheet Guide',

  'notFound.title': 'Article non trouvé',
  'notFound.text':
    'La page que vous recherchez n\'existe pas. Retournez à la page d\'accueil pour explorer nos guides.',
  'notFound.backToHome': 'Retour à l\'accueil',

  'home.metaDescription':
    'Explorez les guides Basetao Spreadsheet, les découvertes, les avis, les coûts d\'expédition, les informations sur l\'entrepôt, les conseils de contrôle qualité, les coupons et les ressources pratiques.',
};